import {Grid} from "@mui/system";
import {DateTimeField, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {DefaultCardStructure} from "components";
import {format} from "date-fns";
import {ptBR} from "date-fns/locale";
import {CCT_ACTIVITIES_IDS} from "global/constants";
import pxToRem from "hooks/usePxToRem";
import {useWatch} from "react-hook-form";

const CCTInfo = () => {
  const activities = useWatch({name: "groupActivity.activities"});

  const cctEnviado = activities?.find(
    (activity) => activity.task.id === CCT_ACTIVITIES_IDS.DECLARAR_CCT,
  )?.finishedAt;

  const cctConferido = activities?.find(
    (activity) =>
      activity.task.id === CCT_ACTIVITIES_IDS.CONFIRMAR_TRANSMISSAO_CCT,
  )?.finishedAt;

  const formattedDates = {
    cctEnviado: cctEnviado
      ? new Date(format(new Date(cctEnviado), "yyyy-MM-dd'T'HH:mm"))
      : null,
    cctConferido: cctConferido
      ? new Date(format(new Date(cctConferido), "yyyy-MM-dd'T'HH:mm"))
      : null,
  };

  return (
    <DefaultCardStructure
      title="CCT"
      linkId="cct"
      hasDivider={false}
      isSubcard={true}
      sx={{width: "100%"}}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
        <Grid container size={12} columnSpacing={pxToRem(8)}>
          <Grid
            size={{xs: 3}}
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
          >
            <DateTimeField
              label="CCT Enviado"
              value={formattedDates.cctEnviado}
              format="EEE, dd/MM/yyyy - HH:mm"
              disabled={true}
              slotProps={{
                textField: {
                  inputProps: {style: {fontSize: pxToRem(14)}},
                  size: "small",
                  fullWidth: true,
                },
              }}
            />
          </Grid>
          <Grid size={{xs: 3}}>
            <DateTimeField
              label="CCT Conferido"
              value={formattedDates.cctConferido}
              format="EEE, dd/MM/yyyy - HH:mm"
              disabled={true}
              slotProps={{
                textField: {
                  inputProps: {style: {fontSize: pxToRem(14)}},
                  size: "small",
                  fullWidth: true,
                },
              }}
            />
          </Grid>
        </Grid>
      </LocalizationProvider>
    </DefaultCardStructure>
  );
};

export default CCTInfo;
